import { useEffect, useState } from "react"
import {
    SELECTION_TYPES, 
    // SELECTION_TYPE_LABELS
} from "@meddbriefer/scenario-data/constants"
// import { useScenarioEditor } from "./ScenarioEditorContext"

const getLabel = (obj) => !obj.abbrLabel  ? obj.label : obj.abbrLabel
// const escapeQuotes = (txt) => txt.replace(/"/g, '\\"')
const escapeQuotes = (text) => text

const GroupWrapper = ({children}) => {
    return (
        <ul style={{
                marginLeft: "5px",
                marginBottom: "10px",
                listStyle: "none",
            }}
        >
            {children}
        </ul>
    )
}
const CheckboxGroup = ({name, options, getter, setter}) => {
    const changeHandler = (event) => {
        const oldValue = getter()
        const {value, checked} = event.target
        let newValue
        if(checked) {
            if (!oldValue.includes(value)) {
                newValue = oldValue.concat(value)                   
            } else {
                // do nothing
                newValue = [...oldValue]
            }
        } else {
            newValue = oldValue.filter(e => e !== value)
        }
        // console.log(oldValue, value, checked, newValue)
        setter(newValue)
    }

    return (
        <GroupWrapper>
            {options.map((option, i) =>
                <li key={i}>
                    <label>
                        <input
                            type="checkbox"
                            name={escapeQuotes(name)}
                            value={option.value}
                            checked={getter().includes(option.value)}
                            onChange={changeHandler}
                        />
                        &nbsp; {option.label}
                    </label>
                </li>
            )}
        </GroupWrapper>
    )

}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RadioGroup = ({name, options, getter, setter}) => {

    const changeHandler = (event) => {
        const {value} = event.target
        setter(value)
    }

    return (
        <GroupWrapper>
            {options.map((option, i) =>
                <li key={i}>
                    <label>
                        <input
                            type="radio"
                            name={escapeQuotes(name)}
                            value={option.value}
                            checked={option.value === getter()}
                            onChange={changeHandler}
                        />
                        &nbsp; {option.label}
                    </label>
                </li>
            )}
        </GroupWrapper>
    )
}

const describeCorrectAnswerSemantics = (selectionType) => {
    switch(selectionType) {
        case SELECTION_TYPES.OOM_AND:
            return "Student correctness requires all answers selected below (logical AND)"
        case SELECTION_TYPES.OOM_OR:
            return "Student correctness requires at least one of the answers selected below (logical OR)"
        case SELECTION_TYPES.OOM:
            return "FIXME: THE SELECTION TYPE FOR THIS PROMPT MUST BE SET TO EITHER 'one-or-more-logical-and' OR 'one-or-more-logical-or"
        case SELECTION_TYPES.ONE: 
            return "Student correctness requires that one of the selected below is chosen"
        default:
            return "FIXME: UNSUPPORTED SELECTION TYPE. UPDATE THIS PROMPT"
    } 
}
const IntvVariantPrompt = ({intv, variant, prompt, stateGetter, stateSetter}) => {
    // console.log(prompt)
    const getValue = () => stateGetter(intv.id, variant, prompt.id)
    const setValue = (value) => stateSetter(intv.id, variant, prompt.id, value)

    return (
        <div style={{marginLeft: "10px"}}>
            <i>{prompt.label}</i>  <span style={{fontSize: "smaller"}}>({describeCorrectAnswerSemantics(prompt.selectionType)})</span>
            <CheckboxGroup
                name={`${intv.id}.${variant}.${prompt.id}`}
                options={
                    prompt.answers.map(ans => {
                        return {
                            value: ans.id,
                            label: getLabel(ans)
                        }
                    })
                }
                getter={getValue}
                setter={setValue}
            />
        </div>
    )
}
// {prompt.selectionType === SELECTION_TYPES.ONE
//  ? <RadioGroup
//         name={`${intv.id}.${variant}.${prompt.id}`}
//         options={
//             prompt.answers.map(ans => {
//                 return {
//                     value: ans.id,
//                     label: getLabel(ans)
//                 }
//             })
//         }
//         getter={getValue}
//         setter={setValue}
//     />

const IntvVariantPrompts = ({intvID, variantJSON, intvLabel, variantDesc, contexts, intvGetter, promptValueGetter, promptValueSetter}) => {
    // const {scenario, scenarioType} = useScenarioEditor()
    const [intv, setIntv] = useState(null)

    useEffect(
        () => {
            if (!intv) {
                setIntv(intvGetter(intvID))
            }
        }, [intvID, intv, intvGetter]
    )
    if (!intv) {
        return (<div>calculating</div>)
    }
    return (
        <div>
            <div>
                <b>Intervention: </b> {intvLabel}
                {"" === variantDesc ? " " : `: ${variantDesc} `}
                <b> Used By: </b> {contexts}
            </div>
            <ul>
            {intv.prompts.map(prompt =>
                <li key={prompt.id}>
                    <IntvVariantPrompt
                        intv={intv}
                        variant={variantJSON}
                        prompt={prompt}
                        stateGetter={promptValueGetter}
                        stateSetter={promptValueSetter}
                    />
                </li>
            )}
            </ul>

        </div>
    )

}


export default IntvVariantPrompts